import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["mobilephone", "email", "lang", "success", "submit"];

  initialize() {}

  toggleSuccess() {
    this.submitTarget.classList.remove("Button--hidden");
    this.successTarget.classList.add("Button--hidden");
  }
}
